import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { toRefs } from 'vue';
import TourDesktop from './TourDesktop.vue';
import TourMobile from './TourMobile.vue';
import { useGlobalStore } from '@/stores/global';


export default /*#__PURE__*/_defineComponent({
  __name: 'Tour',
  setup(__props) {

const store = useGlobalStore();
const { isMobile } = toRefs(store);

return (_ctx: any,_cache: any) => {
  return (_unref(isMobile))
    ? (_openBlock(), _createBlock(TourMobile, { key: 0 }))
    : (_openBlock(), _createBlock(TourDesktop, { key: 1 }))
}
}

})